// IMPORTS
// Modules
import { useState } from 'react';
import $ from 'jquery';
// OHS
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormSelectBuilder, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../../onehivesystems/js/OHSForm';
// Assets
import Fields from '../../Device/Modules/Fields';


// COMPONENT
export default function FindAndReplace (props) {
   // States and Variables
   const [selectedField, setSelectedField] = useState("");

   // Functions
   const replace = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/findandreplace',
         method: 'PUT',
         payload: buildPayload(),
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Performing this action will replace the value in the selected field for all ports matched by the given parameters with the value provided. Are you sure you wish to continue? This action is IRREVERSIBLE!",
         showSuccessPopup: true
      });
   }
   const buildPayload = function () {
      // Build Parameters
      var master = JSON.parse(OHSFormDataExtractor('oneport-bulkactions-findandreplace-parameters'));

      // Build Devices
      master['devices'] = JSON.parse(OHSFormDataExtractor('oneport-bulkactions-findandreplace-devices-list'));

      // Return Data
      return JSON.stringify(master);
   }
   const clear = function () {
      // Clear Parameters
      OHSFormDataClearer('oneport-bulkactions-findandreplace-parameters');

      // Clear Devices
      OHSFormDataClearer('oneport-bulkactions-findandreplace-devices-list');
   }
   const toggleSelectedField = function () {
      setSelectedField($("#oneport-bulkactions-findandreplace-parameters-field").val());
   }
   const toggleAllDevices = function () {
      if($("#oneport-bulkactions-findandreplace-devices-selectall").is(':checked')) {
         $("#oneport-bulkactions-findandreplace-devices-list input[type='checkbox']").each(function (i, input) {
            $(input).prop('checked', true);
         });
      } else {
         $("#oneport-bulkactions-findandreplace-devices-list input[type='checkbox']").each(function (i, input) {
            $(input).prop('checked', false);
         });
      }
   }

   // Component
   return (
      <div className="oneport-bulkactions-findandreplace" onKeyDown={(e) => {OHSFormSubmitListener(e, replace);}}>
         <div id="oneport-bulkactions-findandreplace-parameters" className='oneport-bulkactions-findandreplace-parameters'>
            <OHSFormItem onehive={props.onehive} title="Search Field">
               <OHSFormSelectBuilder onehive={props.onehive} id="oneport-bulkactions-findandreplace-parameters-field" content={props.parent.fields} object={true} objectName="name" objectValue="id" blank={true} ohsformdata="field" onchange={toggleSelectedField} />
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Comparison">
               <OHSFormSelectBuilder onehive={props.onehive} content={["equals", "does not equal", "contains", "does not contain"]} simple={true} blank={false} ohsformdata="comparison" />
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Search Value">
               {props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
                  if (field.id === selectedField) {
                     return (
                        <Fields onehive={props.onehive} key="oneport-bulkactions-findandreplace-parameters-findvalue" parent={{
                           type: field.type,
                           disabled: false,
                           ohsformdata: "find_value",
                           selectContent: field.options && field.options.split("\n"),
                           selectSimple: true,
                           selectBlank: true
                        }} />
                     );
                  }
               })}
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Replace Value">
               {props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
                  if (field.id === selectedField) {
                     return (
                        <Fields onehive={props.onehive} key="oneport-bulkactions-findandreplace-parameters-replacevalue" parent={{
                           type: field.type,
                           disabled: false,
                           ohsformdata: "replace_value",
                           selectContent: field.options && field.options.split("\n"),
                           selectSimple: true,
                           selectBlank: true
                        }} />
                     );
                  }
               })}
            </OHSFormItem>
         </div>
         <div className='oneport-bulkactions-findandreplace-devices'>
            <p>On the following devices:</p>
            <OHSFormItem onehive={props.onehive} title="SELECT ALL">
               <input id="oneport-bulkactions-findandreplace-devices-selectall" type='checkbox' className='ohsinput' onChange={toggleAllDevices} />
            </OHSFormItem>
            <div id="oneport-bulkactions-findandreplace-devices-list" className='oneport-bulkactions-findandreplace-devices-list'>
               {props.parent.devices && props.parent.devices.length > 0 && props.parent.devices.map(function (device, i) {
                  return (
                     <OHSFormItem onehive={props.onehive} key={`oneport-bulkactions-findandreplace-devices-list-item-${i}`} title={device.name}>
                        <input type='checkbox' className='ohsinput' data-ohsformdata={device.id} />
                     </OHSFormItem>
                  );
               })}
            </div>
         </div>
         <OHSFormSubmit onehive={props.onehive} custom={[
            {
               title: "Perform Replacement",
               action: replace,
               class: "ohsbtn-success"
            },
            {
               title: "Clear",
               action: clear,
               class: "ohsbtn"
            }
         ]} keyListener={true} />
      </div>
   )
}